import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

const PasswordRequirement = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-blue-50 border border-blue-200 flex items-center p-3 mt-3 justify-center rounded-md px-4 text-bioport-blue text-sm">
      <FontAwesomeIcon icon={faInfoCircle} className="text-lg mr-3" />{" "}
      {t("login.password.rules")}
    </div>
  );
};

export default PasswordRequirement;
